module.exports = __webpack_public_path__ + "media/memory-bank/mastery-avatar-923fa811.png";